<template>
  <div class="modal fade in hmodal-info" id="welcomeFreeTrialModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="color-line"></div>
        <div class="modal-body text-center m-t m-b"><h3>Welcome to our demo page!</h3>
          <h3> You may try another query or register for free to the full platform</h3>
          <div class="row m-t-lg m-b">
            <div class="col-sm-6 text-center">
              <button type="button" data-dismiss="modal" class="btn btn-lg btn-info btn-outline">Close</button>
            </div>
            <div class="col-sm-6 text-center">
              <button type="button" class="btn btn-lg btn-info">Free account signup</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import VueLadda from 'vue-ladda'

export default {
  components: {
    VueLadda
  },
  name: 'WelcomeFreeTrialModal',
  methods: {
    register: function () {
      let emailParam = localStorage.getItem('freeTrialEmail') ? {email: localStorage.getItem('freeTrialEmail')} : {}
      this.$auth.logout({
        makeRequest: true,
        redirect: {name: 'Register', params: emailParam},
        success () {
          this.$salesMachine.clearUser()
          $('.modal-backdrop').hide()
        },
        error () {
        }
      })
    }
  },
  mounted () {
    if (this.$user.isFreeTrial()) {
      $('#welcomeFreeTrialModal').modal()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/WelcomeFreeTrialModal.vue